"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.list.searchPlaceholder': '搜索访问策略...',
};
